<template>
  <div class="view system staffs">
    <div class="page">
      <div class="header">
        <h2>Company Staffs Management</h2>
      </div>
      <div class="content">
        <div class="card">
          <div class="card-header card-header-flex">
            <div class="d-flex flex-column justify-content-center mr-auto">
              <h5 class="mb-0">Company Staffs List</h5>
            </div>
            <div class="d-flex flex-column justify-content-center">
              <span>
                <a-button type="default" icon="sync" class="mr-2" @click="fetch"> Refresh </a-button>
                <a-button type="primary" icon="user" @click="onNewStaff"> New Staff </a-button>
              </span>
            </div>
          </div>
          <!-- table -->
          <StaffsListTable :staffs="staffs" :pagination="pagination" :loading="loading" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { StaffsListTable } from '@/components/reno/tables'
import store from '@/store'
import router from '@/router'

const KEY = 'staffs'

export default {
  components: {
    StaffsListTable,
  },
  methods: {
    async fetch() {
      await this.$store.dispatch('staffs/fetchStaffs')
    },
    onNewStaff() {
      this.$store.dispatch('staffs/open', 'CREATE_STAFF')
    },
    onEdit(id) {
      this.$router.push({ name: 'staff-detail', params: { id } })
    },
  },
  computed: {
    loading() {
      return this.$store.getters['staffs/loading'](KEY)
    },
    staffs() {
      return this.$store.getters['staffs/data'](KEY)
    },
    pagination() {
      return this.$store.getters['staffs/pagination'](KEY)
    },
    meta() {
      return this.$store.getters['staffs/meta'](KEY)
    },
  },
  async created() {
    await this.fetch()
  },
  mounted() {
    // console.log(this.projects)
  },
  destroyed() {
    // store.dispatch('pm/init')
  },
}
</script>

<style lang="scss" scoped></style>
